import React from 'react';
import './Loader.scss';

const Loader = ({ isLoading }) => {
  return (
    <div className={`loader-container ${!isLoading ? 'hide' : ''}`}>
      <div className="loader-content">
        <span className="loading-text">LOADING</span>
      </div>
    </div>
  );
};

export default Loader;